import Konva from 'konva';
import * as _ from 'lodash';

import { resetPanelShowForPanelPage } from '../../store/senAppProjects.action';
import { DrawFence } from '../fence/DrawFence';
import { ScaleAdjustmentValue } from '../getScaleFactor';
import { PanelAutofillArea } from '../input/PanelAutofillArea';
import { SC_Input } from '../input/SC_Input';
import DrawPanels from '../konva/drawPanels';
import * as konva from '../konva/getCanvas';
import {
	getHgroups,
	getListbyBlocks,
} from '../mountsys/PanelRowManager';
import { MountingType } from '../mountsys/MountingType';
import { Sol50 } from '../mountsys/Sol50';
import { RoofShape } from '../roof/RoofShape';
import { RoofType } from '../roof/RoofType';
import { Global } from '../utilities/global';
import checkForInvalid from './checkForInvalidPanels';
import { DrawRoofForPanel } from './drawRoofForPanel';
import { ModList } from './ModList';
import { Modul } from './Modul';
import SnapPanel from './panelssnap';
import genaratePanelSave from './savePanelDetails';

export class ModGroup {
	public iCount: number;
	public static selectedPanels: any[];
	public static listOfselectedPanels: any[] = [];
	public static group: any = null;
	static isMouseDown: boolean = false;
	static currentSelectedGroup: any = null;
	static onMouseOverPanel: any = null;
	static panelsListBlocks: any = null;
	static panelsDetails: any = {
		topLeft: null,
		topRight: null,
		bottomLeft: null,
		bottomRight: null,
	};
	public add(o: Modul): void {
		this.iCount++;
	}
	public remove(o: Modul): void {
		this.iCount--;
	}
	// handling draw panels on drop of panels 
	static addGroupOfModuls(rows: number, columns: number, x1: number, y1: number, layerPanel: any, ModWidth: number, ModHeight: number, panelSave?: boolean) {
		const list = [];
		for (let i = 1; i <= rows; i++) {
			let x = x1;
			for (let j = 1; j <= columns; j++) {
				list.push({ x: x, y: y1, w: ModWidth, h: ModHeight });
				x = x + ModWidth + Sol50.nHorizontalAbstand;
			}
			y1 = y1 + ModHeight + Sol50.nVertikalAbstand;
		}
		let overlapping = false;

		const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
		if (nonUsableArea && nonUsableArea.length > 0 && !overlapping) {
			for (let j = 0; j < list.length; j++) {
				if (!overlapping) {
					const targetDetails = {
						x: list[j].x,
						y: list[j].y,
						width: list[j].w,
						height: list[j].h
					}
					overlapping = !DrawFence.isEligibletoDraw(targetDetails);
				}
			}
		}

		if (!overlapping) {
			new DrawPanels().drawPanels(list);
			setTimeout(() => {
				ModGroup.checkInvalidPanels();
			}, 200);
			setTimeout(() => {
				genaratePanelSave();
			}, 500);
		}

	}

	static checkInvalidPanels() {
		if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT) {
			return;
		}
		if (ModGroup.currentSelectedGroup) {
			let obj: any = ModGroup.currentSelectedGroup.find("." + Global.panelsOnRoof);
			if (obj && obj.length > 0) {
				obj.forEach((panel: any) => {
					checkForInvalid(panel, true, ModGroup.currentSelectedGroup.getX(), ModGroup.currentSelectedGroup.getY())
				});
			}
		}
		var panels: any = DrawRoofForPanel.panelGroup.find("." + Global.panelsOnRoof);
		if (panels && panels.length > 0) {
			panels.forEach((panel: any) => {
				checkForInvalid(panel);
			});
		}
	}
	// 
	//  For group Snap functionality finding boundaries of group
	// Like top left corner panel, bottom right corner, ..... etc
	static genarateBoundariesFOrGroup() {
		let obj: any = ModGroup.currentSelectedGroup.find("." + Global.panelsOnRoof);
		let list: any[] = [];
		if (obj && obj.length > 0) {
			obj.forEach((panel: any) => {
				list.push({ ...panel.getAttrs() });
			});
			list = _.sortBy(list, 'y');
			const group = _.groupBy(list, 'y');
			const keys = Object.keys(group).map((i) => {
				return parseFloat(i)
			}).sort();
			const topRow = _.sortBy(group[keys[0]], 'x');
			const bottomRow = _.sortBy(group[keys[keys.length - 1]], 'x');
			ModGroup.panelsDetails.topLeft = topRow[0];
			ModGroup.panelsDetails.topRight = topRow[topRow.length - 1];
			ModGroup.panelsDetails.bottomLeft = bottomRow[0];
			ModGroup.panelsDetails.bottomRight = bottomRow[bottomRow.length - 1];
		}

	}
	// show selected panels as one group
	// 
	static drawSelectedModules() {
		// if (ModList.currentSelectedPanel) ModList.removeSelection();
		Modul.removeSelection();
		let overlapping = false;
		var start = { x: 0, y: 0 };
		let listOfGroups = ModList.listOfGroups;
		ModGroup.currentSelectedGroup = new Konva.Group({
			draggable: true,
			x: 0,
			y: 0,
			name: "panelGroupSelected",
			opacity: DrawRoofForPanel.panelGroup.opacity()
		});
		DrawRoofForPanel.layerPanel.add(ModGroup.currentSelectedGroup);
		ModList.selectedPanels.forEach((item) => {
			var obj: any = DrawRoofForPanel.panelGroup.find("#" + item)[0];
			if (obj?.getAttrs()?.name == "panelsOnRoof") {
				obj.moveTo(ModGroup.currentSelectedGroup);
				obj.setDraggable(false);
				obj.find('.border')[0].opacity(1);
				obj.off('dragstart')
				obj.off('dragmove')
				obj.off('dragend')
				obj.off('mousedown');
				obj.off('click');
				obj.on("mousedown", () => {
					this.onMouseOverPanel = obj;
				});
			}

		});

		ModList.selectedPanels = [];
		var layer: any = DrawRoofForPanel.layerPanel;
		DrawRoofForPanel.elipseGroup.moveToTop();
		let panelGroup: any;
		let pList: any;
		let shape: any;
		let targetPanel: any;
		try {
			ModGroup.currentSelectedGroup.on("mousedown mousemove mouseup", (evt: any) => {
				evt.cancelBubble = true;
			});
			ModGroup.currentSelectedGroup.on('dragstart', (e: any) => {
				e.cancelBubble = true;
				if (ModGroup.currentSelectedGroup) {
					start.x = ModGroup.currentSelectedGroup.getX();
					start.y = ModGroup.currentSelectedGroup.getY();

				} else {
					ModGroup.delUnWantedGroup();
				}
				panelGroup = DrawRoofForPanel.panelGroup.find("." + Global.panelsOnRoof);
				pList = panelGroup.length > 0 ? getGroupsList(panelGroup, false) : [];
			});
			ModGroup.currentSelectedGroup.on('dragend', (e: any) => {
				Modul.isPanelMoved = true;
				if (shape && shape.getX()) {
					const gropPosX = shape.getX() - targetPanel.x;  //- ModGroup.onMouseOverPanel.getX();
					const gropPosY = shape.getY() - targetPanel.y;  // ModGroup.onMouseOverPanel.getY();
					if (ModGroup.currentSelectedGroup) {
						ModGroup.currentSelectedGroup.setX(ModGroup.currentSelectedGroup.getX() + gropPosX);
						ModGroup.currentSelectedGroup.setY(ModGroup.currentSelectedGroup.getY() + gropPosY);
					}
					DrawRoofForPanel.shapeGroup.removeChildren();
					shape = null;
					ModGroup.onMouseOverPanel = null;
					DrawRoofForPanel.layerPanel.draw();
				}
				if (ModGroup.currentSelectedGroup) {
					e.cancelBubble = true;
					// clear all previous lines on the screen
					layer.find('.guid-line').destroy();
					// const s = 120;
					let w = RoofShape.getCurrentRoofWidth() + 80;
					let h = RoofShape.getCurrentRoofHeight() + 80;
					const groupList: any[] = [];
					// const roof = { x: s, y: s, width: w, height: h };
					let obj: any = ModGroup.currentSelectedGroup.find("." + Global.panelsOnRoof);
					let xDiff = ModGroup.currentSelectedGroup.getX();
					let yDiff = ModGroup.currentSelectedGroup.getY();
					let minx = 0, miny = 0, maxx = 0, maxy = 0;
					let sw: number = 0, sh: number = 0;
					const idList: any[] = [];
					if (obj && obj.length > 0) {
						obj.forEach((panel: any) => {
							const x = panel.getX() + xDiff;
							const y = panel.getY() + yDiff;
							groupList.push({
								x,
								y,
								width: panel.width(),
								height: panel.height()
							})
							idList.push(panel.getId());
							if (minx == 0) {
								minx = maxx = x;
								miny = maxy = y;
							} else {
								if (x > maxx) {
									maxx = x;
									sw = panel.width();
								}
								if (x < minx) minx = x;
								if (y > maxy) {
									maxy = y;
									sh = panel.height();
								}
								if (y < miny) miny = y;
							}
						});
					}
					maxx += sw + 200;
					maxy += sh + 200;
					minx -= 200;
					miny -= 200;
					const list: any[] = getListbyBlocks(miny, maxy, minx, maxx)
					const listAfterFilter = list.filter((i) => { return idList.indexOf(i.id) == -1 });
					listAfterFilter.forEach((group: any) => {
						groupList.forEach((targetRect: any) => {
							if (Modul.haveIntersection(group, targetRect)) {
								overlapping = true;
							}
						});
					});
					const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
					if (nonUsableArea && nonUsableArea.length > 0 && !overlapping) {
						let over = false
						groupList.forEach((targetRect: any) => {
							if (!over) {
								over = !DrawFence.isEligibletoDraw(targetRect);
							}
						});
						overlapping = over;
						// nonUsableArea.forEach((item: any) => {
						// 	if (item.getClassName() == "Circle") {
						// 		const rect = item.getClientRect();
						// 		const details = { ...item.getAttrs() };
						// 		const r = ScaleAdjustmentValue.reverseScale(rect.width) / 2;
						// 		details.radius = r;
						// 		groupList.forEach((targetRect: any) => {
						// 			if (DrawFence.checkAllCornersOfPanels(details, targetRect)) {
						// 				overlapping = true;
						// 			}
						// 		});
						// 	}
						// 	if (item.getClassName() === "Line" && item.getPoints().length == 6) {
						// 		let p = item.getPoints();
						// 		const finalPoints: any = [];
						// 		for (let i = 0; i < p.length; i = i + 2) {
						// 			const pDiff: any = item.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
						// 			const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
						// 			const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
						// 			finalPoints.push(x);
						// 			finalPoints.push(y);
						// 		}
						// 		// p = finalPoints;
						// 		groupList.forEach((targetRect: any) => {
						// 			if (!DrawFence.PanelIsInFenceTriangle(finalPoints, targetRect)) {
						// 				overlapping = true;
						// 			}
						// 		});
						// 	}
						// 	if (item.getClassName() === "Line" && item.getPoints().length == 8) {
						// 		ModGroup.currentSelectedGroup.getChildren().forEach((i: any) => {
						// 			const targetRect = i.getClientRect();
						// 			if (Modul.haveIntersection(item.getClientRect(), targetRect)) {
						// 				overlapping = true;
						// 			}
						// 		});
						// 	}
						// });
					}
					if (overlapping) {
						ModGroup.currentSelectedGroup.setX(start.x);
						ModGroup.currentSelectedGroup.setY(start.y);
						overlapping = false;
						DrawRoofForPanel.layerPanel.batchDraw();
					} else {
						if (SC_Input.iPnlFillArea != PanelAutofillArea.ALL) {
							let obj: any = ModGroup.currentSelectedGroup.find("." + Global.panelsOnRoof);
							if (obj && obj.length > 0) {
								obj.forEach((panel: any) => {
									checkForInvalid(panel, true, xDiff, yDiff)
								});
							}
						}
					}

				} else {
					ModGroup.delUnWantedGroup();
				}
				DrawRoofForPanel.layerPanel.batchDraw();
				genaratePanelSave();
			});
			ModGroup.currentSelectedGroup.on('dragmove', (e: any) => {
				if (ModGroup.currentSelectedGroup && ModGroup.onMouseOverPanel && pList.length > 0) {
					let values: any = {};
					let panel = {};
					e.cancelBubble = true;
					const list: any[] = [
						ModGroup.panelsDetails.topLeft,
						ModGroup.panelsDetails.topRight,
						ModGroup.panelsDetails.bottomLeft,
						ModGroup.panelsDetails.bottomRight
					];
					for (let z = 0; z < list.length; z++) {
						if (values.x > 20 && values.y > 20) {
							break;
						} else {
							const p = list[z];
							panel = {
								x: p.x + ModGroup.currentSelectedGroup.getX(),
								y: p.y + ModGroup.currentSelectedGroup.getY(),
								width: p.width,
								height: p.height,
								id: p.id
							};
							targetPanel = {
								...panel
							}
							for (let a = 0; a < pList.length; a++) {
								values = SnapPanel.snapCal(pList[a], panel);
								if (values.x > 20 && values.y > 20) {
									break;
								}

							}
						}
					}

					if (values.x > 20 && values.y > 20) {
						if (shape && shape.getX()) {
							DrawRoofForPanel.shapeGroup.removeChildren();
							DrawRoofForPanel.layerPanel.batchDraw();
						}
						shape = konva.getCanvasRect({
							x: values.x,
							y: values.y,
							width: values.w,
							height: values.h,
							fill: "rgb(255, 255, 255,0.5)",
							name: "shapeOnMove"
						});
						DrawRoofForPanel.shapeGroup.add(shape);
						shape.draw();
						var obj: any = ModGroup.currentSelectedGroup.find("." + Global.panelsOnRoof);
						if (obj && obj.length > 0) {
							obj.forEach((item: any) => {
								if (item.getId() != targetPanel.id) {
									const gropPosX = shape.getX() - targetPanel.x;
									const gropPosY = shape.getY() - targetPanel.y;
									const s = konva.getCanvasRect({
										x: item.getAttrs().x + gropPosX + ModGroup.currentSelectedGroup.getX(),
										y: item.getAttrs().y + gropPosY + ModGroup.currentSelectedGroup.getY(),
										width: item.getAttrs().width,
										height: item.getAttrs().height,
										fill: "rgb(255, 255, 255,0.5)",
										name: "shapeOnMove"
									});
									DrawRoofForPanel.shapeGroup.add(s);
									s.draw();
								}
							});
						}
					} else {
						shape = null;
						DrawRoofForPanel.shapeGroup.removeChildren();
						DrawRoofForPanel.layerPanel.batchDraw();
					}
				} else {
					ModGroup.delUnWantedGroup();
				}
				setTimeout(() => {
					listOfGroups = getHgroups();
				}, 1);
			});
		} catch (err) {
			const g: any = DrawRoofForPanel.layerPanel.find(".panelGroupSelected_del");
			if (g && g.length > 0) g.forEach((i: any) => {
				i.destroy();
			})
		}
		DrawRoofForPanel.layerPanel.batchDraw();
		this.genarateBoundariesFOrGroup();
	}

	static removeGroupFromStage() {
		ModGroup.currentSelectedGroup.destroy();
		ModGroup.currentSelectedGroup = null;
		DrawRoofForPanel.layerPanel.draw();
	}
	static delUnWantedGroup() {
		const g: any = DrawRoofForPanel.layerPanel.find(".panelGroupSelected_del");
		if (g && g.length > 0) g.forEach((i: any) => {
			i.destroy();
		})
	}

	// deselecting the selected group 
	static moveBackToMainGroup() {
		var obj: any = ModGroup.currentSelectedGroup.find("." + Global.panelsOnRoof);
		var xDiff = ModGroup.currentSelectedGroup.getX();
		var yDiff = ModGroup.currentSelectedGroup.getY();
		if (obj && obj.length > 0) {
			obj.forEach((panel: any) => {
				panel.setX(panel.getX() + xDiff);
				panel.setY(panel.getY() + yDiff);
				panel.find('.border')[0].opacity(0);
				panel.moveTo(DrawRoofForPanel.panelGroup);
				Modul.bindEventsForModule(panel);
			});
		}

		DrawRoofForPanel.layerPanel.batchDraw();
		ModGroup.currentSelectedGroup.setName("panelGroupSelected_del")
		ModGroup.currentSelectedGroup = null;
		setTimeout(() => {
			const g: any = DrawRoofForPanel.layerPanel.find(".panelGroupSelected_del");
			if (g && g.length > 0) g.forEach((i: any) => {
				i.destroy();
			})
			DrawRoofForPanel.layerPanel.batchDraw();
		}, 100);
	}

	// Canvas stage event bind
	//   used to select group of panels
	//   used to draw new Obstruction on roof
	static groupSelectionEventBinding() {
		var start = {
			x: 0,
			y: 0
		}
		var end = {
			x: 0,
			y: 0
		}
		const roofW = RoofShape.getCurrentRoofWidth();
		const roofH = RoofShape.getCurrentRoofHeight();
		var selectedPortionRect: any = null;
		var shape: any = null;
		const lineH = new Konva.Line({
			points: [
				0,
				0,
				roofW,
				roofH,
			],
			stroke: '#fff',
			strokeWidth: 0,
		});
		const lineV = new Konva.Line({
			points: [
				roofW,
				0,
				roofW,
				roofH,
			],
			stroke: '#fff',
			strokeWidth: 0,
		});
		const textX = new Konva.Text({
			x: 0,
			y: 0,
			text: "X: ",
			fontSize: 16 / DrawRoofForPanel.stage.scaleX(),
			fontFamily: 'intro',
			fill: "#fff",
		});
		const textY = new Konva.Text({
			x: 0,
			y: 0,
			text: "Y: ",
			fontSize: 16 / DrawRoofForPanel.stage.scaleX(),
			fontFamily: 'intro',
			fill: "#fff",
		});

		//draw obstruction coords and circle points
		const textX1 = new Konva.Text({
			x: 0,
			y: 0,
			text: "X: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textY1 = new Konva.Text({
			x: 0,
			y: 0,
			text: "Y: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textX2 = new Konva.Text({
			x: 0,
			y: 0,
			text: "X: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textY2 = new Konva.Text({
			x: 0,
			y: 0,
			text: "Y: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textX3 = new Konva.Text({
			x: 0,
			y: 0,
			text: "X: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textY3 = new Konva.Text({
			x: 0,
			y: 0,
			text: "Y: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textWidth = new Konva.Text({
			x: 0,
			y: 0,
			text: "Y: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});
		const textHeight = new Konva.Text({
			x: 0,
			y: 0,
			text: "Y: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});


		const textDiameter = new Konva.Text({
			x: 0,
			y: 0,
			text: "Diameter: ",
			fontSize: 30,
			fontFamily: 'intro',
			fill: "#fff",
			name: "obstructionText",
			shadowColor: 'white',
			shadowBlur: 10,
			shadowOffsetX: 10,
			shadowOffsetY: 10,
			shadowOpacity: 0.5,

		});

		const centerPointCirle = new Konva.Circle({
			x: 0,
			y: 0,
			stroke: '#666',
			fill: 'red',
			strokeWidth: 2,
			radius: 12,
			name: "obstructionCirclePoints",
			draggable: false,
			dragOnTop: false,

		});
		const toprectCircle = new Konva.Circle({
			x: 0,
			y: 0,
			stroke: '#666',
			fill: 'red',
			strokeWidth: 2,
			radius: 12,
			name: "obstructionCirclePoints",
			draggable: false,
			dragOnTop: false,

		});
		const bottomrectCircle = new Konva.Circle({
			x: 0,
			y: 0,
			stroke: '#666',
			fill: 'red',
			strokeWidth: 2,
			radius: 12,
			name: "obstructionCirclePoints",
			draggable: false,
			dragOnTop: false,

		});

		const toptrianCircle = new Konva.Circle({
			x: 0,
			y: 0,
			stroke: '#666',
			fill: 'red',
			strokeWidth: 2,
			radius: 20,
			name: "obstructionCirclePoints",
			draggable: false,
			dragOnTop: false,

		});
		const btmlfttrianCircle = new Konva.Circle({
			x: 0,
			y: 0,
			stroke: '#666',
			fill: 'red',
			strokeWidth: 2,
			radius: 20,
			name: "obstructionCirclePoints",
			draggable: false,
			dragOnTop: false,

		});

		const btmrgttrianCircle = new Konva.Circle({
			x: 0,
			y: 0,
			stroke: '#666',
			fill: 'red',
			strokeWidth: 2,
			radius: 20,
			name: "obstructionCirclePoints",
			draggable: false,
			dragOnTop: false,

		});

		DrawRoofForPanel.layerPanel.add(lineH, lineV, textX, textY);
		//  mousedown event binding starts
		DrawRoofForPanel.stage.on("mousedown", (event: any) => {

			//clear obstructions if already present
			//DrawFence.clearObstructionTextIfAlreadyPresent();
			DrawFence.isTransformEnabled = false;

			DrawFence.storeObj.dispatch(resetPanelShowForPanelPage({ resetPanelShow: false }));
			if (!DrawRoofForPanel.stage.getDraggable()) {
				var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
				var isInRange = true;
				start.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
				start.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
				this.isMouseDown = true;
				if (ModList.currentSelectedPanel) {
					Modul.deselection();
				}
				if (ModGroup.currentSelectedGroup) {
					this.moveBackToMainGroup();
				}
				DrawFence.removeTransformNodes();
				DrawRoofForPanel.layerPanel.batchDraw();
			}
		});
		//  mousedown event binding ends

		//  mouseup event binding starts
		DrawRoofForPanel.stage.on("mouseup", (event: any) => {
			//console.log('mouseup event')
			lineV.strokeWidth(0);
			lineH.strokeWidth(0);
			textX.x(-200);
			textX.y(-200);
			textY.x(-200);
			textY.y(-200);
			this.isMouseDown = false;
			if (selectedPortionRect) {//destroy if panels are selected
				selectedPortionRect.destroy();
			}

			DrawFence.storeObj.dispatch(resetPanelShowForPanelPage({ resetPanelShow: false }));//panel move while on subframe view fix
			// if (ModGroup.currentSelectedGroup == null || DrawFence.currentSelectedShape == null || true) {
			// if (this.stopSelectionPanelsWhileDrag) {

			var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
			end.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();// * DrawRoofForPanel.currentScale;
			end.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();// * DrawRoofForPanel.currentScale;
			const diffX = Math.abs(start.x - end.x);
			const diffY = Math.abs(start.y - end.y);
			if (diffX > 1 && diffY > 1) {
				if (DrawFence.drawShapeEnable && start.x != 0 && start.y != 0) {
					if (shape) {
						shape.destroy();
					}

					//console.log('draw shape obj',shape);
					shape = DrawFence.drawShapeRef.drawShape(start, end, Global.nonUsableArea, null);

					DrawRoofForPanel.layerPanel.add(shape);
					shape.draw();



					DrawFence.bindEventsForShape(shape);
					const s = { ...start };
					const e = { ...end };
					setTimeout(() => {
						// DrawFence.clearPanels();
						DrawFence.clearPanelsForShape(s, e, shape);
						DrawFence.drawShapeEnable = false;
						var oldDom: any = document.getElementsByClassName("sen-activebg-fence");
						if (oldDom.length > 0) oldDom[0].classList.remove("sen-activebg-fence");
						shape = null;
					}, 100);
				} else {
					if (start.x != 0 && start.y != 0) {

						//console.log(' panels select');

						// selecting panels
						var xValues: any = [], yValues: any = [], flagX = true;
						if (selectedPortionRect && selectedPortionRect.attrs)
							selectedPortionRect.attrs.points.forEach((point: any) => {
								if (flagX) {
									if (xValues.indexOf(point) == -1) xValues.push(point);
								} else {
									if (yValues.indexOf(point) == -1) yValues.push(point);
								}
								flagX = !flagX
							});
						var minX = xValues[0] > xValues[1] ? xValues[1] : xValues[0];
						var maxX = xValues[0] < xValues[1] ? xValues[1] : xValues[0];
						var minY = yValues[0] > yValues[1] ? yValues[1] : yValues[0];
						var maxY = yValues[0] < yValues[1] ? yValues[1] : yValues[0];
						var obj: any = getListbyBlocks(minY, maxY, minX, maxX);
						// console.log("FILTER list", obj);
						if (obj && obj.length > 0)
							obj.forEach((item: any) => {
								// console.log(item)
								var x = item.x;
								var y = item.y;
								var w = item.width;
								var h = item.height;
								var panelIsInRange = false;
								if (x > minX && x < maxX && y > minY && y < maxY) {
									panelIsInRange = true;
								}
								if ((x + w / 2) > minX && (x + w / 2) < maxX && y > minY && y < maxY) {
									panelIsInRange = true;
								}
								if ((x) > minX && (x) < maxX && (y + h) > minY && (y + h) < maxY) {
									panelIsInRange = true;
								}
								if ((x) > minX && (x) < maxX && (y + h / 2) > minY && (y + h / 2) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w) > minX && (x + w) < maxX && (y + h / 2) > minY && (y + h / 2) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w) > minX && (x + w) < maxX && (y + h / 2) > minY && (y + h / 2) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w) > minX && (x + w) < maxX && (y) > minY && (y) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w / 2) > minX && (x + w / 2) < maxX && (y + h) > minY && (y + h) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w / 2) > minX && (x + w / 2) < maxX && (y + h) > minY && (y + h) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w) > minX && (x + w) < maxX && (y + h) > minY && (y + h) < maxY) {
									panelIsInRange = true;
								}
								if ((x + w * 3 / 4) > minX && (x + w) < maxX && (y) > minY && (y) < maxY) {//3/4 width left
									panelIsInRange = true;
								}
								if ((x + w * 1 / 4) > minX && (x + w) < maxX && (y) > minY && (y) < maxY) {//1/4 width left
									panelIsInRange = true;
								}
								if ((x + w * 3 / 4) > minX && (x + w) < maxX && (y + h) > minY && (y + h) < maxY) {//3/4 width right
									panelIsInRange = true;
								}
								if ((x + w * 1 / 4) > minX && (x + w) < maxX && (y + h) > minY && (y + h) < maxY) {//1/4 width right
									panelIsInRange = true;
								}

								if ((x) > minX && (x) < maxX && (y + h) > minY && (y + h * 3 / 4) < maxY) {//3/4 height left
									panelIsInRange = true;
								}
								if ((x) > minX && (x) < maxX && (y + h * 1 / 4) > minY && (y + h * 1 / 4) < maxY) {//1/4 height left
									panelIsInRange = true;
								}
								if ((x + w) > minX && (x + w) < maxX && (y + h) > minY && (y + h * 3 / 4) < maxY) {//3/4 height right
									panelIsInRange = true;
								}
								if ((x + w) > minX && (x + w) < maxX && (y + h * 1 / 4) > minY && (y + h * 1 / 4) < maxY) {//1/4 height right
									panelIsInRange = true;
								}
								if (panelIsInRange) {
									ModList.selectedPanels.push(item.id);
								}
							});
					}

					//selecting particular portion of panels for drag 
					if (ModList.selectedPanels.length > 0) {
						if (ModList.selectedPanels.length > 1) {
							this.drawSelectedModules();
						} else {
							const obj: any = DrawRoofForPanel.layerPanel.find("#" + ModList.selectedPanels[0])[0];
							obj.setDraggable(true);
							obj.find('.border')[0].opacity(1);
							ModList.currentSelectedPanel = obj;
							ModList.currentSelectedPanel.on('mousedown', (e: any) => {
								e.cancelBubble = true;
							});
							DrawRoofForPanel.layerPanel.batchDraw();
							ModList.selectedPanels = [];
						}
					}
				}
			} else {
				// DrawFence.drawShapeEnable = false;
			}

			selectedPortionRect = null;
			// }
			DrawRoofForPanel.layerPanel.batchDraw();
			setTimeout(() => {
				start = {
					x: 0,
					y: 0
				}
				end = {
					x: 0,
					y: 0
				}
			}, 1);
		});
		//  mouseup event binding ends

		//  mousemove event binding starts
		DrawRoofForPanel.stage.on("mousemove", (event: any) => {
			if (DrawRoofForPanel.isViewPanelsEnabled)
				if (this.isMouseDown) {
					var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
					end.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();// * DrawRoofForPanel.currentScale;
					end.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();// * DrawRoofForPanel.currentScale;
					if (DrawFence.drawShapeEnable) {
						if (shape) {
							shape.destroy();
						}
						var oldShape: any = DrawRoofForPanel.layerPanel.find(".fenceShapeOnMove");
						//console.log('fenceShapeOnMove',oldShape);
						oldShape.forEach((item: any) => {
							item.destroy();
						});
						shape = DrawFence.drawShapeRef.drawShape(start, end, "fenceShapeOnMove");
						DrawRoofForPanel.layerPanel.add(shape);
						lineV.strokeWidth(4);
						lineH.strokeWidth(4);
						lineV.points([
							end.x,
							0,
							end.x,
							roofH + 100,
						]);
						lineH.points([
							0,
							end.y,
							roofW + 100,
							end.y,
						]);
						lineH.moveToTop();
						lineV.moveToTop();

						//draw obstruction text and circle points during drawing

						DrawFence.clearObstructionTextIfAlreadyPresent();
						DrawFence.updateTextWithCoordinates(shape, textX1, textY1, textX2, textY2
							, textX3, textY3, textHeight, textWidth, textDiameter, centerPointCirle, toprectCircle
							, bottomrectCircle, toptrianCircle, btmlfttrianCircle, btmrgttrianCircle);

					} else {
						// selecting panels on roof
						const start_x = start.x;
						const start_y = start.y;
						const end_x = end.x;
						const end_y = end.y;
						if (selectedPortionRect) {
							//destroy if already selected
							selectedPortionRect.destroy();
						}
						//draw select rectangle - green 
						//for disable slection on drag and drop triangle points
						if (DrawFence.selectPotionRect) {
							selectedPortionRect = new Konva.Line({
								points: [start_x, start_y, end_x, start_y, end_x, end_y, start_x, end_y],
								fill: "rgb(255, 255, 255,0.5)",
								closed: true,
							});
							DrawRoofForPanel.layerPanel.add(selectedPortionRect);
						}

					}
					DrawRoofForPanel.layerPanel.batchDraw();
				}
		});

		//  mousemove event binding ends
		DrawRoofForPanel.stage.on("click", (event: any) => {
			//if (ModList.currentSelectedPanel) {
			//	console.log('panel click event');
			//	ModList.currentSelectedPanel.setDraggable(false);
			//}
			// 
			// 	const a = ModList.currentSelectedPanel.find('.border');
			// 	if (a && a[0]) a[0].opacity(0);
			// 	ModList.currentSelectedPanel = null;
			// }
			// if (ModGroup.currentSelectedGroup) {
			// 	this.moveBackToMainGroup();
			// 	// console.log("mouse down mg")
			// }
			// DrawFence.removeTransformNodes();
			// DrawRoofForPanel.layerPanel.draw();
		});
	}

}

// retuns groups of rows which panels are connected with 0.7cm distance.
function getGroupsList(panels: any, selectedGroup: boolean): any[] {

	var listPanels: any[] = panels.map((i: any) => {
		return { ...i.getAttrs() }
	});

	var aTmp: any[] = _.sortBy(listPanels, 'y');
	var r1: number[] = [];
	var r2: any[] = [];
	var r3: any[] = []
	var panelRows: any = [];
	var listOfGroups: any = [];
	aTmp.forEach((i: any) => {
		if (r1.indexOf(i.y) == -1) {
			if (r2.length > 0) {
				r3.push(r2);
			}
			r1.push(i.y);
			r2 = [];
			r2.push(i);
		} else {
			r2.push(i);
		}
	});
	r3.push(r2);

	r3.forEach((item: any) => {
		var r4 = _.sortBy(item, 'x');
		var temp: any = [];
		var nModWidth: number = r4[0].width;
		r4.forEach((i: any, index) => {
			if (index > 0) {
				var gap: number = parseFloat((i.x - r4[index - 1].x - nModWidth).toFixed(1));
				if (gap == Sol50.nHorizontalAbstand) {
					temp.push(i)
				} else {
					listOfGroups.push([...temp]);
					temp = [];
					temp.push(i);
				}
			} else temp.push(i)
		});
		listOfGroups.push([...temp]);
	});


	return listOfGroups;
}